// extracted by mini-css-extract-plugin
module.exports = {"container":"UserTestimonialCard_container__DaR2W","imageContainer":"UserTestimonialCard_imageContainer__gAIhw","bodyContainer":"UserTestimonialCard_bodyContainer__VwPpw"};